import React from 'react';

const Link = ({ children, url }) => {
  return (
    <a href={url} target="_blank" rel="noopener noreferrer">
      <div className="flex items-center space-x-1">
        <span className="flex-1">{children}</span>
      </div>
    </a>
  );
};

export default Link;
